/**
 * Serviço de Email para Operadores
 * Usa Resend para enviar convites de boas-vindas
 */

interface EmailOperadorPayload {
  to: string;
  fullName: string;
  empresaNome: string;
  linkCadastro?: string;
}

/**
 * Gerar HTML do email de boas-vindas para novo operador
 */
export function gerarEmailBemvindoOperador(dados: EmailOperadorPayload): string {
  const linkCadastro = dados.linkCadastro || `${window.location.origin}/login`;

  return `
<!DOCTYPE html>
<html lang="pt-BR">
<head>
  <meta charset="utf-8">
  <meta name="viewport" content="width=device-width, initial-scale=1.0">
  <title>Bem-vindo ao Ateliê Pro</title>
  <style>
    * { margin: 0; padding: 0; }
    body {
      font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', sans-serif;
      line-height: 1.6;
      color: #333;
      background: #f5f5f5;
    }
    .container {
      max-width: 600px;
      margin: 0 auto;
      background: white;
      border-radius: 8px;
      overflow: hidden;
      box-shadow: 0 2px 10px rgba(0,0,0,0.1);
    }
    .header {
      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
      color: white;
      padding: 40px 20px;
      text-align: center;
    }
    .header h1 { font-size: 28px; margin-bottom: 5px; }
    .header p { font-size: 14px; opacity: 0.9; }
    .content { padding: 40px 20px; }
    .content p { margin-bottom: 15px; font-size: 15px; }
    .welcome-box {
      background: #f0f4ff;
      border-left: 4px solid #667eea;
      padding: 20px;
      margin: 25px 0;
      border-radius: 4px;
    }
    .welcome-box p { margin-bottom: 10px; font-size: 14px; }
    .welcome-title {
      color: #667eea;
      font-weight: bold;
      margin-bottom: 12px;
      font-size: 14px;
    }
    .info-box {
      background: #f9f9f9;
      border: 1px solid #eee;
      padding: 20px;
      margin: 25px 0;
      border-radius: 4px;
    }
    .info-box p { margin-bottom: 8px; font-size: 14px; }
    .info-label { color: #667eea; font-weight: bold; }
    .button {
      display: inline-block;
      background: #667eea;
      color: white;
      padding: 14px 32px;
      text-decoration: none;
      border-radius: 4px;
      font-weight: bold;
      margin: 25px auto;
      font-size: 14px;
      text-align: center;
      width: 100%;
      box-sizing: border-box;
    }
    .button:hover { background: #5568d3; }
    .section-title {
      font-size: 16px;
      font-weight: bold;
      margin-top: 25px;
      margin-bottom: 12px;
      color: #333;
    }
    .feature-list { margin: 15px 0 0 0; }
    .feature-item {
      padding: 8px 0;
      font-size: 14px;
      border-bottom: 1px solid #eee;
    }
    .feature-item:last-child { border-bottom: none; }
    .step-number {
      display: inline-block;
      background: #667eea;
      color: white;
      width: 24px;
      height: 24px;
      border-radius: 50%;
      text-align: center;
      line-height: 24px;
      margin-right: 10px;
      font-weight: bold;
      font-size: 12px;
    }
    .footer {
      background: #f9f9f9;
      padding: 20px;
      border-top: 1px solid #eee;
      text-align: center;
      font-size: 12px;
      color: #666;
    }
    .footer p { margin-bottom: 5px; }
  </style>
</head>
<body>
  <div class="container">
    <div class="header">
      <h1>✨ Bem-vindo!</h1>
      <p>Ateliê Pro - Gestão Criativa</p>
    </div>

    <div class="content">
      <p>Olá <strong>${escapeHtml(dados.fullName)}</strong>,</p>
      <p>Você foi convidado para ser operador na plataforma <strong>${escapeHtml(dados.empresaNome)}</strong>. Estamos empolgados em tê-lo na equipe!</p>

      <div class="welcome-box">
        <div class="welcome-title">🎯 Suas Permissões</div>
        <p>Como operador, você terá acesso a:</p>
        <div class="feature-list">
          <div class="feature-item">📋 Gerenciamento de Pedidos e Orçamentos</div>
          <div class="feature-item">💰 Controle Financeiro e Fluxo de Caixa</div>
          <div class="feature-item">📦 Gestão de Estoque</div>
          <div class="feature-item">👥 CRM de Clientes</div>
          <div class="feature-item">📊 Relatórios e Análises</div>
          <div class="feature-item">📅 Agenda e Planejamento</div>
        </div>
      </div>

      <a href="${escapeHtml(linkCadastro)}" class="button">Acessar Ateliê Pro Agora →</a>

      <div class="section-title">🚀 Como Começar</div>
      <div class="info-box">
        <p><span class="step-number">1</span> Clique no botão acima</p>
        <p><span class="step-number">2</span> Faça login com este email</p>
        <p><span class="step-number">3</span> Crie sua senha segura</p>
        <p><span class="step-number">4</span> Comece a usar o Ateliê Pro</p>
      </div>

      <div class="info-box">
        <p><span class="info-label">📧 Email de Acesso:</span> ${escapeHtml(dados.to)}</p>
        <p><span class="info-label">🏢 Empresa:</span> ${escapeHtml(dados.empresaNome)}</p>
        <p style="font-size: 13px; color: #666; margin-top: 12px;">Sua senha será criada na primeira vez que você fizer login.</p>
      </div>

      <div class="section-title">❓ Precisa de Ajuda?</div>
      <p>Se tiver dúvidas sobre como usar o Ateliê Pro:</p>
      <div class="info-box">
        <p>📚 Acesse o <strong>Centro de Ajuda</strong> dentro da plataforma</p>
        <p>🎥 Assista aos <strong>Tutoriais em Vídeo</strong></p>
        <p>💬 Fale com nosso suporte via <strong>WhatsApp</strong></p>
      </div>

      <p style="margin-top: 30px; font-style: italic; color: #666; font-size: 14px;">
        Estamos entusiasmados em tê-lo na equipe! 💜
      </p>
    </div>

    <div class="footer">
      <p>© 2026 Ateliê Pro - Gestão Criativa. Todos os direitos reservados.</p>
      <p style="margin-top: 8px;">Este é um email automático. Não responda a este endereço.</p>
    </div>
  </div>
</body>
</html>
  `.trim();
}

/**
 * Função auxiliar para escapar HTML
 */
function escapeHtml(text: string): string {
  if (!text) return '';
  const map: Record<string, string> = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#039;'
  };
  return text.replace(/[&<>"']/g, (m) => map[m]);
}

/**
 * Enviar email de boas-vindas para novo operador
 * Usa Resend como provedor de email via Edge Function do Supabase
 */
export async function enviarEmailBemvindoOperador(
  dados: EmailOperadorPayload
): Promise<{ success: boolean; message: string; error?: string }> {
  try {
    // URL da Edge Function do Supabase (configure em .env.local)
    const edgeFunctionUrl = import.meta.env.VITE_SUPABASE_SEND_EMAIL_URL;

    if (!edgeFunctionUrl) {
      console.warn('⚠️ VITE_SUPABASE_SEND_EMAIL_URL não configurada. Email não será enviado.');
      console.log('📧 Email que seria enviado:', {
        to: dados.to,
        fullName: dados.fullName,
        empresaNome: dados.empresaNome
      });

      return {
        success: false,
        message: 'Email não configurado ainda, mas operador foi criado com sucesso!',
        error: 'Edge Function URL não configurada'
      };
    }

    const response = await fetch(edgeFunctionUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        to: dados.to,
        full_name: dados.fullName,
        empresa_nome: dados.empresaNome,
        link_cadastro: dados.linkCadastro || `${window.location.origin}/login`
      })
    });

    if (!response.ok) {
      throw new Error(`Erro ao enviar email: ${response.statusText}`);
    }

    const result = await response.json();

    return {
      success: true,
      message: 'Email de boas-vindas enviado com sucesso!'
    };
  } catch (error) {
    console.error('❌ Erro ao enviar email:', error);

    // Não falha a criação do operador se o email falhar
    // Apenas loga o erro
    return {
      success: false,
      error: (error as any).message || 'Erro ao enviar email',
      message: 'Operador criado, mas houve um problema ao enviar o email.'
    };
  }
}
